<template>
  <v-row>
    <v-col cols="12" sm="12" md="8" lg="8">
      <v-text-field
        dense
        flat
        outlined
        background-color="white"
        placeholder="search"
        v-model="search"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="4">
      <v-btn color="success" @click="excel">
        <v-icon>mdi-file-excel</v-icon>
      </v-btn>
    </v-col>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="journals"
        dense
        @click:row="onClickRow"
        :search="search"
      >
        <template v-slot:item.no="{ item }">
          {{ journals.findIndex(x => x === item) + 1 }}
        </template>
        <template v-slot:item.totalDebit="{ item }">
          {{ formatPrice(item.totalDebit) }}
        </template>
        <template v-slot:item.totalCredit="{ item }">
          {{ formatPrice(item.totalCredit) }}
        </template>
        <template v-slot:body.append="{}">
          <tr>
            <td colspan="6">TOTAL</td>
            <td style="border: 1px">
              {{ formatPrice(totalDebit) }}
            </td>
            <td style="border: 1px">
              {{ formatPrice(totalCredit) }}
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">
            Reset
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import fileDownload from "js-file-download";

export default {
  name: "approval-journal",
  data: () => ({
    headers: [
      {
        id: 1,
        text: "No",
        sortable: false,
        value: "no",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 2,
        text: "Title",
        value: "title",
        sortable: false,
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "Description",
        value: "description",
        sortable: false,
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 4,
        text: "Reference",
        value: "reference",
        sortable: false,
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Date",
        value: "date",
        sortable: false,
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Remark",
        value: "remark",
        sortable: false,
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Total Debit",
        value: "totalDebit",
        sortable: false,
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Total Credit",
        value: "totalCredit",
        sortable: false,
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Remark Problem",
        value: "remarkProblem",
        sortable: false,
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
    search: "",
  }),

  computed: {
    ...mapState("journal", ["journals"]),
    filteredJournals() {
      if (!this.search) return this.journals;
      const term = this.search.toLowerCase();
      return this.journals.filter(item => {
        return Object.values(item).some(val =>
          String(val)
            .toLowerCase()
            .includes(term)
        );
      });
    },
    totalDebit() {
      return this.filteredJournals
        .map(x => x.totalDebit)
        .reduce((total, debit) => total + debit, 0);
    },
    totalCredit() {
      return this.filteredJournals
        .map(x => x.totalCredit)
        .reduce((total, credit) => total + credit, 0);
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("journal/getJournalBuffer")
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async excel() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("journal/getJournalBufferExcel")
        .then(response => {
          fileDownload(response.data, "journal-buffer.xlsx");
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    onClickRow(item) {
      this.$router.push({ name: "Detail Journal", params: { id: item.id } });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style></style>
